export default function isAgeValid(birthDate, minAge = 14) {
  if (!birthDate) return false;

  const today = new Date();
  const birth = new Date(birthDate);

  // Calcula a idade
  let age = today.getFullYear() - birth.getFullYear();
  const monthDiff = today.getMonth() - birth.getMonth();

  // Ajusta a idade se ainda não fez aniversário este ano
  if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birth.getDate())) {
    age -= 1;
  }

  return age >= minAge;
}
